export default __webpack_public_path__ + "static/media/expiryDate3.a19c67a9.jpg";